import * as t from './actionTypes';
import * as api from './api';

// load users
export function loadUsers() {
  return (dispatch) => {
    dispatch({ type: t.SET_BUSY });

    api.getUsers((success, users, error) => {
      if (success) {
        dispatch({ type: t.USER_LOAD_SUCCESS, users: users });
        dispatch({ type: t.UNSET_BUSY });
      } else if (error) {
        dispatch({ type: t.UNSET_BUSY });
      }
    });
  }
}

// select user
export function selectUser(data) {
  return (dispatch) => {
    dispatch({ type: t.SELECT_USER, payload: data.userId });
  }
}

// create a new user
export function createNewUser(data, successCB, errorCB) {
  return (dispatch) => {
    dispatch({ type: t.SET_BUSY });
    api.createNewUser(data, function(success, data, error) {
      if (success) {
        dispatch({ type: t.USER_CREATE_SUCCESS, user: data });
        dispatch({ type: t.UNSET_BUSY });
        successCB();
      } else if (error) {
        dispatch({ type: t.UNSET_BUSY });
        errorCB(error);
      }
    })
  }
}

// edit an existing user
export function editUser(id, data, successCB, errorCB) {
  return (dispatch) => {
    dispatch({ type: t.SET_BUSY });

    api.editUser(id, data, function(success, data, error) {
      if (success) {
        dispatch({ type: t.USER_EDIT_SUCCESS, id: id, user: data });
        dispatch({ type: t.UNSET_BUSY });
        successCB();
      } else if (error) {
        dispatch({ type: t.UNSET_BUSY });
        errorCB(error);
      }
    })
  }
}

// remove from admins
export function removeFromAdmins(id, cb) {
  return (dispatch) => {
    dispatch({ type: t.SET_BUSY });
    api.removeFromAdmins(id, function(success, error) {
      if (success) {
        dispatch({ type: t.ADMIN_REMOVE_SUCCESS, id: id });
      }
      dispatch({ type: t.UNSET_BUSY });
      cb();
    })
  }
}

// change admin rights
export function changeAdminRights(id, data, cb) {
  return (dispatch) => {
    dispatch({ type: t.SET_BUSY });

    api.changeAdminRights(id, data, function(success, error) {
      if (success) {
        dispatch({ type: t.ADMIN_CHANGE_SUCCESS, id: id });
      }
      dispatch({ type: t.UNSET_BUSY });
      cb();
    })
  }
}

// delete existing user
export function deleteUser (id) {
  return (dispatch) => {
    dispatch({ type: t.SET_BUSY });

    api.deleteUser(id, (success, error) => {
      if (success) {
        dispatch({ type: t.USER_DELETE_SUCCESS, id: id });
        dispatch({ type: t.UNSET_BUSY });
      } else if (error) {
        console.log(error);
        dispatch({ type: t.UNSET_BUSY });
      }
    })
  }
}
